module.exports = __webpack_public_path__ + "img/ipage 3.4e018a72.png";